import React from 'react';

const AzureCaseStudySection = ({
  logo = "../assets/images/migration/BANDIT2tkk.png",
  logoAlt = "Client Success Story",
  badgeText = "Success Story",
  title = "Successful Azure Infrastructure Migration",
  description = "A growing business migrated its azure infrastructure to a more cost-efficient environment, improving operational efficiency while significantly reducing monthly cloud expenses.",
  ctaText = "View Success Story",
  ctaLink = "#",
  stats = [
    { id: 1, value: "70%", label: "Cost Reduction" },
    { id: 2, value: "$2,000 → $600", label: "Monthly Spending" },
    { id: 3, value: "4 Months", label: "ROI Achieved" }
  ]
}) => {
  const ArrowIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="ml-2 w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
      />
    </svg>
  );

  const getValueColor = (index) => {
    const colors = ['text-green-400', 'text-white', 'text-green-300'];
    return colors[index % colors.length];
  };

  return (
    <section className="py-10 bg-gradient-to-br from-green-600 via-emerald-600 to-green-700">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-green-400/30">
          <div className="flex flex-col md:flex-row items-center gap-8">

            <div className="flex-shrink-0">
              <img
                src={logo}
                alt={logoAlt}
                className="h-16 w-auto "
                loading="lazy"
              />
            </div>

            <div className="flex-1 text-center md:text-left">
              <span className="text-green-400 font-semibold text-sm uppercase tracking-wider">
                {badgeText}
              </span>

              <h3 className="text-2xl md:text-3xl font-bold text-white mt-2 mb-4">
                {title}
              </h3>

              <p className="text-gray-300 mb-6">
                {description}
              </p>

              <div className="flex flex-wrap gap-6 justify-center md:justify-start mb-6">
                {stats.map((stat, index) => (
                  <div key={stat.id}>
                    <div className={`text-3xl font-bold ${getValueColor(index)}`}>
                      {stat.value}
                    </div>
                    <div className="text-gray-300 text-sm">
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>

              <a
                href={ctaLink}
                className="inline-flex items-center text-green-400 hover:text-green-300 font-semibold transition-colors duration-300"
              >
                {ctaText}
                <ArrowIcon />
              </a>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default AzureCaseStudySection;